module.exports = __webpack_public_path__ + "static/media/newMSG.1f56b356.mp3";